import { Button, Input, Popconfirm, Table } from "antd";
import { Plus, Trash } from "lucide-react";
import { experienceDetailsInitialValues } from "./enum";
import trashIcon from "../../images/red-trash-icon.svg";
import { Col, Form, Row } from "react-bootstrap";

const TotalExperienceTable = ({ errors, details, setDetails, loading }) => {
  const handleChange = (index, field, value) => {
    setDetails((prev) => {
      const updatedData = [...prev.data];
      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      return { ...prev, data: updatedData };
    });
  };

  const columns = [
    {
      title: "",
      dataIndex: "sr_no",
      key: "sr_no",
      // width: 3,
      align: "center",
      render: (text, record, index) => (
        <div className="fw-semibold">{index + 1}.</div>
      ),
    },
    {
      title: (
        <span>
          Organization <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_name",
      key: "itl_name",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            value={text}
            placeholder="Organization"
            className={`${errors[index]?.itl_name ? "error" : ""}`}
            onChange={(e) => handleChange(index, "itl_name", e.target.value)}
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_name}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Designation <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_designation",
      key: "itl_designation",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            value={text}
            placeholder="Designation"
            className={`${errors[index]?.itl_designation ? "error" : ""}`}
            onChange={(e) =>
              handleChange(index, "itl_designation", e.target.value)
            }
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_designation}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          CTC <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_salarydrawn",
      key: "itl_salarydrawn",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            type="number"
            value={text}
            placeholder="CTC"
            className={`${errors[index]?.itl_salarydrawn ? "error" : ""}`}
            onChange={(e) =>
              handleChange(index, "itl_salarydrawn", e.target.value)
            }
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_salarydrawn}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Period From <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_periodfrom",
      key: "itl_periodfrom",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            type="date"
            value={text ? text.slice(0, 10) : ""}
            className={`${errors[index]?.itl_periodfrom ? "error" : ""}`}
            onChange={(e) =>
              handleChange(index, "itl_periodfrom", e.target.value)
            }
            disabled={loading}
            max={new Date().toISOString().split("T")[0]}
          />
          <div className="input-error">{errors[index]?.itl_periodfrom}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Period To <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_periodto",
      key: "itl_periodto",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            type="date"
            value={text ? text.slice(0, 10) : ""}
            className={`${errors[index]?.itl_periodto ? "error" : ""}`}
            onChange={(e) =>
              handleChange(index, "itl_periodto", e.target.value)
            }
            disabled={loading}
            max={new Date().toISOString().split("T")[0]}
          />
          <div className="input-error">{errors[index]?.itl_periodto}</div>
        </div>
      ),
    },
    // {
    //   title: "Address",
    //   dataIndex: "itl_address",
    //   key: "itl_address",
    //   render: (text, record, index) => (
    //     <div className="d-flex flex-column align-items-start">
    //       <Input
    //         value={text}
    //         placeholder="Address"
    //         className={`${errors[index]?.itl_address ? "error" : ""}`}
    //         onChange={(e) => handleChange(index, "itl_address", e.target.value)}
    //         disabled={loading}
    //       />
    //       <div className="input-error">{errors[index]?.itl_address}</div>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Reason for Leaving",
    //   dataIndex: "itl_reasonforleaving",
    //   key: "itl_reasonforleaving",
    //   render: (text, record, index) => (
    //     <div className="d-flex flex-column align-items-start">
    //       <Input
    //         value={text}
    //         placeholder="Reason"
    //         className={`${errors[index]?.itl_reasonforleaving ? "error" : ""}`}
    //         onChange={(e) =>
    //           handleChange(index, "itl_reasonforleaving", e.target.value)
    //         }
    //         disabled={loading}
    //       />
    //       <div className="input-error">
    //         {errors[index]?.itl_reasonforleaving}
    //       </div>
    //     </div>
    //   ),
    // },
    {
      title: "Remove",
      dataIndex: "remove",
      key: "remove",
      fixed: "right",
      render: (text, record, index) => (
        <div className="d-flex justify-content-center">
          {index !== 0 && index !== 1 ? (
            <Popconfirm
              title={`Remove ${record.itl_name || "experience"}?`}
              onConfirm={() => handleDelete(index)}
              okText="Yes"
              cancelText="No"
            >
              <Trash
                className="text-danger cursor-pointer"
                style={{ height: "20px", width: "20px" }}
              />
            </Popconfirm>
          ) : (
            <Trash
              className="text-secondary cursor-not-allowed"
              style={{ height: "20px", width: "20px" }}
            />
          )}
        </div>
      ),
    },
  ];

  const handleDelete = (index) => {
    setDetails((prev) => {
      const updatedData = [...prev.data];
      const deletedItem = updatedData[index];
      updatedData.splice(index, 1);

      const updatedDeletedData = [...prev.deletedData];
      if (deletedItem?.itl_experiencedetailid) {
        updatedDeletedData.push(deletedItem.itl_experiencedetailid);
      }

      return {
        ...prev,
        data: updatedData,
        deletedData: updatedDeletedData,
      };
    });
  };

  const handleAddNewRow = () => {
    setDetails((prev) => ({
      ...prev,
      data: [...prev.data, { ...experienceDetailsInitialValues }],
    }));
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-end mb-3">
        <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-end gap-1 gap-lg-2">
          <h5 className="mb-0">Total Experience</h5>
          <div className="custom-font-size">(Recent on top / Minimum two)</div>
        </div>
        <Button
          type="primary"
          onClick={handleAddNewRow}
          disabled={loading}
          className="d-none d-lg-flex btn-blue border-none"
        >
          <Plus style={{ height: "15px", width: "15px" }} />
          <div>Add Experience</div>
        </Button>
      </div>
      <hr />
      <div className="d-none d-lg-block">
        <Table
          size="small"
          columns={columns}
          dataSource={details.data || []}
          pagination={false}
          scroll={{ x: "max-content" }}
          className="custom-candidate-form-table"
        />
      </div>

      {/* Mobile view */}
      <div className="d-lg-none">
        {details.data.map((item, index) => (
          <div key={index}>
            {/* Delete button */}
            {index !== 0 && index !== 1 && (
              <div className="d-flex justify-content-end">
                <div className="delete-btn" onClick={() => handleDelete(index)}>
                  <img src={trashIcon} alt="" />
                </div>
              </div>
            )}

            <Row>
              {/* Organization */}
              <Col md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">
                    {index + 1}. Organization
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Organization"
                    value={item.itl_name}
                    className={`${errors[index]?.itl_name ? "error" : ""}`}
                    onChange={(e) =>
                      handleChange(index, "itl_name", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">{errors[index]?.itl_name}</div>
                </Form.Group>
              </Col>

              {/* Designation */}
              <Col md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">
                    Designation
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Designation"
                    value={item.itl_designation}
                    className={`${
                      errors[index]?.itl_designation ? "error" : ""
                    }`}
                    onChange={(e) =>
                      handleChange(index, "itl_designation", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">
                    {errors[index]?.itl_designation}
                  </div>
                </Form.Group>
              </Col>

              {/* CTC */}
              <Col md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">CTC</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="CTC"
                    value={item.itl_salarydrawn}
                    className={`${
                      errors[index]?.itl_salarydrawn ? "error" : ""
                    }`}
                    onChange={(e) =>
                      handleChange(index, "itl_salarydrawn", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">
                    {errors[index]?.itl_salarydrawn}
                  </div>
                </Form.Group>
              </Col>

              {/* Period From */}
              <Col md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">
                    Period From
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={
                      item.itl_periodfrom
                        ? item.itl_periodfrom.slice(0, 10)
                        : ""
                    }
                    className={`${
                      errors[index]?.itl_periodfrom ? "error" : ""
                    }`}
                    onChange={(e) =>
                      handleChange(index, "itl_periodfrom", e.target.value)
                    }
                    disabled={loading}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <div className="input-error">
                    {errors[index]?.itl_periodfrom}
                  </div>
                </Form.Group>
              </Col>

              {/* Period To */}
              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label className="required fw-semibold">
                    Period To
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={
                      item.itl_periodto ? item.itl_periodto.slice(0, 10) : ""
                    }
                    className={`${errors[index]?.itl_periodto ? "error" : ""}`}
                    onChange={(e) =>
                      handleChange(index, "itl_periodto", e.target.value)
                    }
                    disabled={loading}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <div className="input-error">
                    {errors[index]?.itl_periodto}
                  </div>
                </Form.Group>
              </Col>
            </Row>
            {index < details.data.length - 1 && <hr />}
          </div>
        ))}

        <div className="d-flex justify-content-center mt-4">
          <Button className="me-3 btn-blue border-none" type="primary" onClick={handleAddNewRow} disabled={loading}>
            <Plus style={{ height: "15px", width: "15px" }} />
            <div>Add Experience</div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TotalExperienceTable;
